import React from 'react';
import PropTypes from 'prop-types';
import ListBadge from 'components/Common/ListBadge';
import CalendarUtils from 'services/CalendarUtils';

const dateFormat = 'Do MMMM YYYY';

const ImmunizationBadge = ({ item }) => (
  <ListBadge
    title={item.value.description}
    firstLine={`${item.value.name} (${item.value.prescription})`}
    secondLine={getImmunizationDate(item)}
  />
);

function getImmunizationDate(immunization) {
  if (immunization.value.given_date)
    return CalendarUtils.format(immunization.value.given_date, dateFormat);
  return CalendarUtils.format(immunization.history[0].date, dateFormat);
}

ImmunizationBadge.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ImmunizationBadge;
